const Joi = require('joi');
const customerDataSchema = Joi.object({
  hasNoCustomerNumber: Joi.boolean().default(false).optional().messages({
    'boolean.base': 'errors.customer.hasNoNumber.boolean',
    'any.required': 'errors.customer.hasNoNumber.required'
  }),

  customerNumber: Joi.string().trim().when('hasNoCustomerNumber', {
    is: false,
    then: Joi.string().required().messages({
      'string.empty': 'errors.customer.number.required',
      'any.required': 'errors.customer.number.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),
  contactPersonPhone: Joi.string().trim().when('hasNoCustomerNumber', {
    is: false,
    then: Joi.required().messages({
      'string.empty': 'errors.contactPersonPhone.required',
      'any.required': 'errors.contactPersonPhone.required'
    }),
    otherwise: Joi.allow('').optional()
  }),
  contactPersonEmail: Joi.string().email({ tlds: { allow: false } }).when('hasNoCustomerNumber', {
    is: false,
    then: Joi.required().messages({
      'string.empty': 'errors.contactPersonEmail.required',
      'string.email': 'errors.contactPersonEmail.invalid',
      'any.required': 'errors.contactPersonEmail.required'
    }),
    otherwise: Joi.allow('').optional()
  }),
  // Optional for private customers (apps that send customerType); required otherwise
  customerCompany: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.when('customerType', {
      is: 'private',
      then: Joi.allow('').optional(),
      otherwise: Joi.required().messages({
        'string.empty': 'errors.customer.company.required',
        'any.required': 'errors.customer.company.required'
      })
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerCompanyEmail: Joi.string().trim().email({ tlds: { allow: false } }).allow('').optional(),
  customerName: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.name.required',
      'any.required': 'errors.customer.name.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerLastName: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.lastName.required',
      'any.required': 'errors.customer.lastName.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerStreet: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.street.required',
      'any.required': 'errors.customer.street.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerHouseNumber: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.houseNumber.required',
      'any.required': 'errors.customer.houseNumber.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerPostalCodeNumber: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.postalCode.required',
      'string.pattern.base': 'errors.customer.postalCode.invalid',
      'any.required': 'errors.customer.postalCode.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerCity: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.city.required',
      'any.required': 'errors.customer.city.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),

  customerMail: Joi.string().email({ tlds: { allow: false } }).when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.mail.required',
      'string.email': 'errors.customer.mail.invalid',
      'any.required': 'errors.customer.mail.required'
    }),
    otherwise: Joi.string().trim().email({ tlds: { allow: false } }).allow('').optional()
  }),

  customerPhone: Joi.string().trim().when('hasNoCustomerNumber', {
    is: true,
    then: Joi.required().messages({
      'string.empty': 'errors.customer.phone.required',
      'any.required': 'errors.customer.phone.required'
    }),
    otherwise: Joi.string().trim().allow('').optional()
  }),
})
module.exports = customerDataSchema;